import type { IDateUTC } from './models';

/** Получить количество миллисекунд по UTC */
export const getMillisecondsWithUTC = (passedDate: IDateUTC) =>
    Date.UTC(
        passedDate.utcYear,
        passedDate.utcMonth,
        passedDate.utcDate,
        passedDate.utcHour,
        passedDate.utcMinutes,
        passedDate.utcSeconds
    );
